import { TargetSelectionSource } from "@/repository/models/outboundCall";
import { MultiInputItemProps } from "../multiInput";
import { ClipboardEvent } from "react";
import { CallTargetType } from "@/common/types";

export enum OutboundType {
	Call = 0,
	Email = 1,
}

export interface MultiselectSearchProps {
	label?: string;
	value?: string;
	placeholder?: string;
	classesName?: MultiselectClasses;
	actions?: ActionItemProps[];
	items: MultiSelectItemProps[];
	limit?: number;
	autoFocus?: boolean;
	outboundType?: OutboundType;
	isKeyDownHandled?: boolean;
	showClearButton?: boolean;
	onInputChanged?: (value: string) => void;
	onItemSelected: (value: ContactItemData) => void;
	queryFn: (value: string) => Promise<QueryResult[]>;
	onInputPaste?: (e: ClipboardEvent<HTMLInputElement>) => void;
	onInputClear?: () => void;
	disabled?: boolean;
	disableSearchOnMobile?: boolean;
	destinations?: ContactItemData[];
}

export interface QueryResult {
	key: any;
	header: string;
	secondaryHeader?: string;
	content: string;
	data: ItemData;
}

export interface ItemData {
	name: string;
	value: string;
}

export interface ContactItemData extends ItemData {
	contactId: string | undefined;
	selectionSource: TargetSelectionSource | undefined;
	selectionType: CallTargetType | undefined;
	selectionInteractionHistoryId: string | undefined;
}

export interface MultiSelectItemProps extends MultiInputItemProps {}

export interface ActionItemProps {
	label: string;
	action: () => void;
}

export interface MultiselectClasses {
	root?: string;
	input?: string;
	container?: string;
	label?: string;
	contactLabel?: string;
}
